"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLogo = exports.StyledItemDescription = exports.StyledItemHeadingNote = exports.StyledItemHeading = exports.StyledItem = exports.StyledTrack = exports.StyledViewport = exports.transitionMs = exports.visibleCounts = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@phishtool/ui");
const logo_box_1 = require("./logo-box");
// Items visible at <768 / >=768 / >=1024. The carousel reads the same tuple for its step maths,
// so the CSS width and the JS offset can never drift apart.
exports.visibleCounts = [1, 2, 4];
// Shared with the hook, which schedules the loop's snap-back off the same duration
exports.transitionMs = 600;
exports.StyledViewport = styled_components_1.default.div.withConfig({ displayName: "StyledViewport", componentId: "sc-91md4z" }) `
  overflow: hidden;
`;
exports.StyledTrack = styled_components_1.default.ul.withConfig({ displayName: "StyledTrack", componentId: "sc-yoptxh" }) `
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  margin: 0;
  padding: 0;
  list-style: none;
  transform: translateX(-${(props) => props.$offset}%);

  /* Too few items to fill the row reads as broken when left-aligned, but centring an overflowing
     row shifts it off the first item — so compare the count per breakpoint at render time rather
     than waiting on a measurement, which would move the row after the first frame. */
  ${(props) => (0, ui_1.mq)({
    justifyContent: exports.visibleCounts.map((count) => (props.$itemCount > count ? 'flex-start' : 'center')),
})}

  ${(props) => props.$isAnimated &&
    (0, styled_components_1.css) `
      transition: transform ${exports.transitionMs}ms ease-in-out;
    `}
`;
// Spacing is padding rather than a track gap, so one step stays exactly one item wide
exports.StyledItem = styled_components_1.default.li.withConfig({ displayName: "StyledItem", componentId: "sc-1ml4tdl" }) `
  display: flex;
  flex-direction: column;
  align-items: center;

  ${(props) => (0, ui_1.mq)({
    flex: exports.visibleCounts.map((count) => `0 0 ${100 / count}%`),
    gap: [props.theme.spacers.x2, null, props.theme.spacers.x3],
    padding: [`0 ${props.theme.spacers.x3}`, null, `0 ${props.theme.spacers.x6}`],
})}
`;
// The stat is a display size outside the theme's scale, so it's set here rather than via Heading.
// Kept at twice the section heading on each breakpoint (22px -> 44px, 34px -> 68px), so the two
// stay in proportion. -0.02em matches the tracking every typography token uses.
const headingFontSizes = ['44px', null, '68px'];
exports.StyledItemHeading = styled_components_1.default.h3.withConfig({ displayName: "StyledItemHeading", componentId: "sc-16r4hkl" }) `
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: ${(props) => props.theme.spacers.x1};
  margin: 0;
  color: ${(props) => props.theme.body.textColor};
  font-weight: ${(props) => props.theme.fontWeights.medium};
  letter-spacing: -0.02em;
  /* Hugs the digits so a note beside them can align to the top of the numeral, not to half-leading */
  line-height: 1;

  ${(0, ui_1.mq)({ fontSize: headingFontSizes })}
`;
const noteLineHeight = 1.333;
// IBM Plex Sans, as fractions of font size: the line box the face reports, its ascent, and how far
// down the tallest ink actually starts for a lining numeral vs. the note's ascenders.
const fontLineBoxRatio = 1.309;
const fontAscentRatio = 1.029;
const digitInkRatio = 0.71;
const noteInkRatio = 0.75;
// Flex aligns boxes, not glyphs — a numeral's ink starts far below its line box top, the note's
// barely does, so top-aligning the boxes leaves the note sitting high. This is that gap: half-leading
// (which moves with line-height) plus the space the face leaves above its tallest ink.
const inkTopRatio = (lineHeight, inkRatio) => (lineHeight - fontLineBoxRatio) / 2 + (fontAscentRatio - inkRatio);
// Qualifies a stat that doesn't read alone, e.g. "8" / "Of the world's largest technology companies"
exports.StyledItemHeadingNote = styled_components_1.default.span.withConfig({ displayName: "StyledItemHeadingNote", componentId: "sc-v69dpk" }) `
  max-width: 9em;
  text-align: left;
  font-size: ${(props) => props.theme.typography.x1.fontSize};
  font-weight: ${(props) => props.theme.fontWeights.medium};
  letter-spacing: ${(props) => props.theme.typography.x1.letterSpacing};
  line-height: ${noteLineHeight};

  ${(props) => {
    const noteInkTop = parseFloat(props.theme.typography.x1.fontSize) * inkTopRatio(noteLineHeight, noteInkRatio);
    return (0, ui_1.mq)({
        marginTop: headingFontSizes.map((size) => size === null ? null : `${(parseFloat(size) * inkTopRatio(1, digitInkRatio) - noteInkTop).toFixed(2)}px`),
    });
}}
`;
exports.StyledItemDescription = styled_components_1.default.p.withConfig({ displayName: "StyledItemDescription", componentId: "sc-9yl8cj" }) `
  margin: 0;
  text-align: center;
  color: ${(props) => props.theme.colors.oxfordBlue};
  font-size: ${(props) => props.theme.typography.x2.fontSize};
  letter-spacing: ${(props) => props.theme.typography.x2.letterSpacing};
`;
// Every symbol is padded to logoBox by the sprite build, so sizing this box to the box's aspect
// renders all of them at one scale — 1:1 with the design at the desktop height.
const logoHeights = [logo_box_1.logoBox.height * 0.78, null, logo_box_1.logoBox.height];
exports.StyledLogo = styled_components_1.default.svg.withConfig({ displayName: "StyledLogo", componentId: "sc-1ov65sr" }) `
  max-width: 100%;
  color: ${(props) => props.theme.colors.darkEclipse};

  ${(0, ui_1.mq)({
    height: logoHeights.map((height) => (height === null ? null : `${height}px`)),
    width: logoHeights.map((height) => height === null ? null : `${((height * logo_box_1.logoBox.width) / logo_box_1.logoBox.height).toFixed(2)}px`),
})}
`;
